import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LinkWithIcon } from '../../../../../../components/LinkWithIcon';
import { Spinner } from '../../../../../../components/Spinner';
import urls from '../../../../urls';
import EnableBrowserNotificationsPrompt from '../EnableBrowserNotificationsPrompt/EnableBrowserNotificationsPrompt';
import OnsiteNotificationsListItem, {
    Notification,
} from '../OnsiteNotificationsListItem/OnsiteNotificationsListItem';
import OnsiteNotificationsScrollable from '../OnsiteNotificationsScrollable/OnsiteNotificationsScrollable';
import { IconSettings1 } from '@99designs/icons';

export interface Props {
    notifications: Notification[];
    urls: typeof urls;
    onMarkAllRead?: () => void;
    viewportHeightDiff?: number | null;
    isLoading?: boolean;
    webPushVapidPublicKey: string | null;
    showEnableBrowserNotificationsPrompt: boolean;
}

export default class OnsiteNotificationsList extends React.Component<Props> {
    static readonly defaultProps: Partial<Props> = {
        onMarkAllRead: () => { },
        isLoading: true,
    };

    handleMarkAllRead = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (this.props.onMarkAllRead) this.props.onMarkAllRead();
    };

    notifications() {
        const notifications = this.props.notifications;

        if (this.props.isLoading) {
            return (
                <div className="onsite-notifications__spinner">
                    <Spinner />
                </div>
            );
        }

        if (notifications.length === 0) {
            return (
                <div className="onsite-notifications__message-none">
                    <FormattedMessage
                        id="No notifications found."
                        defaultMessage="No notifications found."
                    />
                </div>
            );
        }

        return (
            <OnsiteNotificationsScrollable viewportHeightDiff={this.props.viewportHeightDiff}>
                {notifications.map((notification, key) => {
                    return <OnsiteNotificationsListItem key={key} notification={notification} />;
                })}
            </OnsiteNotificationsScrollable>
        );
    }

    render() {
        return (
            <div className="onsite-notifications__list">
                <div className="onsite-notifications__header">
                    <div className="onsite-notifications__header__heading">
                        <FormattedMessage id="Notifications" defaultMessage="Notifications" />
                    </div>
                    <LinkWithIcon
                        href={this.props.urls.notificationsSettings}
                        icon={<IconSettings1 />}
                        variations={['subtle']}
                    >
                        <FormattedMessage id="Settings" defaultMessage="Settings" />
                    </LinkWithIcon>

                    <EnableBrowserNotificationsPrompt
                        webPushVapidPublicKey={this.props.webPushVapidPublicKey}
                        xhrNotificationsUserFlag={this.props.urls.xhrNotificationsUserFlag}
                        showEnableBrowserNotificationsPrompt={
                            this.props.showEnableBrowserNotificationsPrompt &&
                            this.props.notifications.length > 0 &&
                            !this.props.isLoading
                        }
                    />
                </div>
                {this.notifications()}
                <div className="onsite-notifications__footer">
                    <div className="onsite-notifications__footer__see-all">
                        <a
                            href={this.props.urls.notifications}
                            className="onsite-notifications__link"
                        >
                            <FormattedMessage
                                id="See all notifications"
                                defaultMessage="See all notifications"
                            />
                        </a>
                    </div>
                    <a
                        href="#"
                        className="onsite-notifications__link onsite-notifications__footer__mark-read"
                        onClick={this.handleMarkAllRead}
                    >
                        <FormattedMessage id="Mark all as read" defaultMessage="Mark all as read" />
                    </a>
                </div>
            </div>
        );
    }
}
